import type { LucideIcon } from "lucide-react";

const SIZE = { sm: "h-3.5 w-3.5", md: "h-4 w-4", lg: "h-5 w-5" } as const;

/**
 * One icon, drawn the same way everywhere: an SVG that takes the colour of the
 * text around it (`currentColor`), never a character or an emoji, whose weight
 * and shape change from one browser or operating system to the next.
 *
 * DECORATIVE by default (`aria-hidden`): the words next to it carry the meaning.
 * Pass `label` when the icon stands alone and IS the meaning (a status mark) —
 * it then becomes an image with that name. An icon that is the only content of
 * a button is not this case: use `IconButton`, whose `label` names the button.
 */
export function Icon({
  icon: Glyph,
  size = "md",
  label,
  className = "",
}: {
  icon: LucideIcon;
  size?: keyof typeof SIZE;
  label?: string;
  className?: string;
}) {
  return (
    <Glyph
      aria-hidden={label ? undefined : true}
      role={label ? "img" : undefined}
      aria-label={label}
      className={`shrink-0 ${SIZE[size]} ${className}`}
    />
  );
}
